import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {RegistrationComponent} from './registration/registration.component';

const routes: Routes = [
    {path: 'belepes', component: LoginComponent, data: {page: 'login'}},
    {path: 'regisztracio', component: RegistrationComponent, data: {page: 'registration'}},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/auth-routing.module.ts